export interface ImportSagaState {
  accessPointCount: number;
  completed: Date;
  correlationId: string;
  currentState: SagaStateOptions;
  exception: string;
  initiatedBy: string;
  missingFields: string[];
  providerNetworkId: number;
  providerSource: ProviderSource;
  started: Date;
  versionId: number;
  isLoading: boolean;
}

export enum ProviderSource {
  Desktop = "Desktop",
  Api = "Api",
}

export enum SagaStateOptions {
  None = "",
  PreProcessing = "PreProcessing",
  GettingRunConfiguration = "GettingRunConfiguration",
  GettingCompletionConfiguration = "GettingCompletionConfiguration",
  GettingActivationConfiguration = "GettingActivationConfiguration",
  Processing = "Processing",
  Active = "Active",
  WaitingForInput = "WaitingForInput",
  UploadingToOmnius = "UploadingToOmnius",
  Completion = "Completion",
  CompletionPending = "CompletionPending",
  Activation = "Activation",
  ActivationPending = "ActivationPending",
  PreparingForRestart = "PreparingForRestart",
  ProviderUploadFault = "ProviderUploadFault",
  ProviderValidationFailed = "ProviderValidationFailed",
  CheckingCompletionStatus = "CheckingCompletionStatus",
  Final = "Final",
}
